function sliderInitilised(data){
	data.slick({
		slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        prevArrow: '<button class="pre-btn"><img src="https://cdn.shopify.com/s/files/1/0134/9166/7003/files/arrowImg.svg?v=1600760324" alt="Go back to previous slide"></button>',
        nextArrow: '<button class="next-btn"><img src="https://cdn.shopify.com/s/files/1/0134/9166/7003/files/arrowImg.svg?v=1600760324" alt="Go forward to next slide"></button>',
	}).on('afterChange', function(event, slick, currentSlide){
        var thisE = $(this);
        var sliderW = thisE.find('.slick-active');
        if(sliderW.hasClass('video-content')){
          var vType = sliderW.attr('data-type');
          if(vType == 'external'){
            var iFid = thisE.find('.slick-active iframe').attr('id');
            $('#'+iFid).get(0).contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
          }
          else if(vType == 'custom'){
            sliderW.find('video').trigger('play');;
          }
        }
      }).on('beforeChange', function(event, slick, currentSlide) {
        var thisE = $(this);
        var sliderW = thisE.find('.slick-active');
        if(sliderW.hasClass('video-content')){
          var vType = sliderW.attr('data-type');
          if(vType == 'external'){
            var iFid = thisE.find('.slick-active iframe').attr('id');
            $('#'+iFid).get(0).contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          }
          else if(vType == 'custom'){
            sliderW.find('video').trigger('pause');;
          }
        }
      }).on('setPosition', function (event, slick,currentSlide) {

        var thisE = $(this);
        var sliderW = thisE.find('.slick-active');
        var $images = this.querySelectorAll('.slide img') || [];

        if (!sliderW.hasClass('video-content')) {
          if ($images?.length > 0) {
            var trackHeight = slick.$slideTrack.height();

            $images.forEach(function (image) {
              if (image?.clientHeigth > 0 && image?.clientHeight < trackHeight) {
                image.style.height = trackHeight + 'px';
              }
            });
          }
        }
    });
}
function imageSlider(){
	var targetWrap = $(".section-wrap");
	var targetM = targetWrap.find('.content-slider');
	var contentL = targetM.find('.slide').length;
	if(contentL > 1){
		sliderInitilised(targetM)
	}
}


$(document).ready(function(){;
	imageSlider();
})
